// extracted by mini-css-extract-plugin
export default {"wrapper":"Instructions_wrapper__TUVjA","copy":"Instructions_copy__GAQ+c","action":"Instructions_action__6NJaV","image":"Instructions_image__HGsDg"};